import SecureRequest from "../utils/securerequest";

const clinicianIdQuery = (clinicianId?: string | number) =>
  clinicianId !== undefined && clinicianId !== null && clinicianId !== ""
    ? `?clinician_id=${encodeURIComponent(String(clinicianId))}`
    : "";

export const getDocumentChecklistStatus = async (
  clientId: string | number,
  clinicianId?: string | number
) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.get(
    `/v3/document-checklist/clients/${clientId}/status${clinicianIdQuery(clinicianId)}`
  );
};

export const getDocumentChecklist = async (
  clientId: string | number,
  documentType: string,
  clinicianId?: string | number
) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const url = `/v3/document-checklist/clients/${clientId}/${documentType}${clinicianIdQuery(clinicianId)}`;
  return Request.get(url);
};

// Replaces whatever override the client already had — no need to revoke first.
export const grantDocumentOverride = async (clientId: string | number, documentType: string) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.put(`/v3/document-checklist/clients/${clientId}/override`, { documentType });
};

export const revokeDocumentOverride = async (clientId: string | number) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.delete(`/v3/document-checklist/clients/${clientId}/override`);
};
